import { userService } from '../service'
import { clearAuthStorage, getToken, setToken } from '../auth/storage'
import { disableGoogleAutoSelect } from '../service/google-identity.service'

export const auth = {
  state: {
    token: '',
    user: null,
    initialized: false
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_USER (state, user) {
      state.user = user
    },
    SET_INITIALIZED (state, initialized) {
      state.initialized = initialized
    }
  },
  getters: {
    getToken: state => state.token,
    getUserID: state => state.user?.id || 0
  },
  actions: {
    async initialize ({ commit, dispatch }) {
      const token = getToken()
      commit('SET_TOKEN', token)
      if (token) {
        try {
          await dispatch('getUser')
        } catch (error) {
          if (error?.status === 401) {
            await dispatch('logout')
          }
        }
      }
      commit('SET_INITIALIZED', true)
    },

    async loginWithGoogle ({ commit, dispatch }, credential) {
      const response = await userService.exchangeGoogleCredential('dashboard', credential)
      const token = response?.data?.token
      if (!token) {
        throw new Error('Authentication failed.')
      }
      setToken(token)
      commit('SET_TOKEN', token)
      await dispatch('getUser')
    },

    async getUser ({ commit }) {
      const response = await userService.getInfo()
      commit('SET_USER', response.data)
      return response.data
    },

    logout ({ commit }) {
      clearAuthStorage()
      disableGoogleAutoSelect()
      commit('SET_TOKEN', '')
      commit('SET_USER', null)
    }
  },
  namespaced: true
}
